import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { ContainPopover } from '../../interfaces/contain-popover.interface';
import { TranslateService } from '../../services/translate/translate.service';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'mg-popover-list',
  templateUrl: './popover-list.component.html',
  styleUrls: ['./popover-list.component.scss'],
})
export class PopoverListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() installEvent = null;
  @Output() elementSelected: EventEmitter<any> = new EventEmitter();
  @Output() closePopover: EventEmitter<any> = new EventEmitter();
  some_text = '';
  inside = false;
  language: any[] = [];
  modules: any[] = [];
  unsubscribe$ = new Subject();
  constructor(private translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.modules = [];
    this.language.forEach((element) => {
      if ((element.id === 3 && this.installEvent) || element.id !== 3) {
        this.modules.push(element);
      }
    });
  }

  ngOnInit(): void {
    this.translate
      .init('core')
      .pipe(
        tap((core) => {
          this.language = core.user || [];
          this.modules = [];
          this.language.forEach((element) => {
            if ((element.id === 3 && this.installEvent) || element.id !== 3) {
              this.modules.push(element);
            }
          });
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  @HostListener('click')
  clicked() {
    this.inside = true;
  }

  @HostListener('document:click')
  clickedOut() {
    this.some_text = this.inside
      ? 'Event Triggered'
      : 'Event Triggered Outside Component';
    if (!this.inside) {
      this.closePopover.emit(this.inside);
    }
    this.inside = false;
  }

  valueSelected(item: ContainPopover) {
    this.elementSelected.emit(item);
  }

  ngOnDestroy(): void {
    this.unsubscribe$?.next(null);
    this.unsubscribe$?.complete();
  }
}
